import { atom } from 'jotai';

export const AuthAtoms = {
  isAuth: atom<boolean>(false)
};
